import {useContext} from "react";

import {DishDetailsConfigContext} from "../DishDetailsConfigContext";
import {DishDetailsConfig} from "../interfaces";

export default function useDishDetailsConfig(): DishDetailsConfig {
  return useContext(DishDetailsConfigContext);
}
